// Mobile Carousel Swipe Functionality

document.addEventListener('DOMContentLoaded', function() {
  
  // Add swipe functionality to featured collection carousels
  function addSwipeToCarousels() {
    const carousels = document.querySelectorAll('.featured-collection, .product-grid, .slider-component, .owl-carousel, .collection-list');
    
    carousels.forEach(carousel => {
      addSwipeSupport(carousel);
    });
  }
  
  function addSwipeSupport(element) {
    let startX = 0;
    let startY = 0;
    let distX = 0;
    let distY = 0;
    let threshold = 50; // Minimum distance for swipe
    let restraint = 100; // Maximum distance perpendicular to swipe direction
    let allowedTime = 300; // Maximum time allowed to travel that distance
    let startTime = 0;
    
    element.addEventListener('touchstart', function(e) {
      const touchobj = e.changedTouches[0];
      startX = touchobj.pageX;
      startY = touchobj.pageY;
      startTime = new Date().getTime();
    }, { passive: true });
    
    element.addEventListener('touchmove', function(e) {
      // Only prevent default for actual carousel elements, not collection grids
      const touchobj = e.changedTouches[0];
      distX = touchobj.pageX - startX;
      distY = touchobj.pageY - startY;
      
      // Only prevent default for horizontal swipes on actual carousels/sliders
      // Don't interfere with vertical scrolling on collection pages
      const isCarousel = element.classList.contains('owl-carousel') || 
                        element.closest('slider-component') || 
                        element.querySelector('slider-component') ||
                        element.classList.contains('featured-collection') ||
                        element.classList.contains('slider-component');
      
      if (isCarousel && Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > 30) {
        e.preventDefault();
      }
    }, { passive: false });
    
    element.addEventListener('touchend', function(e) {
      const touchobj = e.changedTouches[0];
      distX = touchobj.pageX - startX;
      distY = touchobj.pageY - startY;
      const elapsedTime = new Date().getTime() - startTime;
      
      if (elapsedTime <= allowedTime && Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
        if (distX > 0) {
          // Swipe right - go to previous
          navigateCarousel(element, 'prev');
        } else {
          // Swipe left - go to next
          navigateCarousel(element, 'next');
        }
      }
    }, { passive: true });
  }
  
  function navigateCarousel(element, direction) {
    // Check for Owl Carousel
    if (element.classList.contains('owl-carousel')) {
      const owlCarousel = $(element);
      if (direction === 'next') {
        owlCarousel.trigger('next.owl.carousel');
      } else {
        owlCarousel.trigger('prev.owl.carousel');
      }
      return;
    }
    
    // Check for Shopify slider component
    const sliderComponent = element.closest('slider-component') || element.querySelector('slider-component');
    if (sliderComponent) {
      const nextBtn = sliderComponent.querySelector('button[name="next"]');
      const prevBtn = sliderComponent.querySelector('button[name="previous"]');
      
      if (direction === 'next' && nextBtn && !nextBtn.disabled) {
        nextBtn.click();
      } else if (direction === 'prev' && prevBtn && !prevBtn.disabled) {
        prevBtn.click();
      }
      return;
    }
    
    // Check for custom slider with scroll
    const slider = element.querySelector('[id^="Slider-"]') || element;
    if (slider && slider.scrollLeft !== undefined) {
      const scrollAmount = slider.clientWidth * 0.8; // Scroll 80% of visible width
      
      if (direction === 'next') {
        slider.scrollTo({
          left: slider.scrollLeft + scrollAmount,
          behavior: 'smooth'
        });
      } else {
        slider.scrollTo({
          left: slider.scrollLeft - scrollAmount,
          behavior: 'smooth'
        });
      }
    }
  }
  
  // Initialize swipe functionality
  addSwipeToCarousels();
  
  // Re-initialize when new content is loaded
  document.addEventListener('shopify:section:load', function() {
    setTimeout(addSwipeToCarousels, 100);
  });
  
  // Also add touch-friendly scrolling for horizontal scrollable elements
  function improveHorizontalScrolling() {
    const horizontalScrollers = document.querySelectorAll('.grid--peek, .slider');
    
    horizontalScrollers.forEach(scroller => {
      // Add momentum scrolling for iOS
      scroller.style.webkitOverflowScrolling = 'touch';
      scroller.style.overflowX = 'auto';
      scroller.style.overflowY = 'hidden';
      
      // Add scroll snap for better UX
      scroller.style.scrollSnapType = 'x mandatory';
      
      const items = scroller.querySelectorAll('.grid__item, .card-wrapper, .product-card-wrapper');
      items.forEach(item => {
        item.style.scrollSnapAlign = 'start';
      });
    });
    
    // Handle collection grids separately - don't restrict vertical scrolling
    const collectionGrids = document.querySelectorAll('.collection-list, .product-grid');
    collectionGrids.forEach(grid => {
      // Only add momentum scrolling, don't restrict overflow
      grid.style.webkitOverflowScrolling = 'touch';
    });
  }
  
  improveHorizontalScrolling();
});

// Add CSS for better mobile carousel experience
const carouselCSS = `
  @media screen and (max-width: 989px) {
    /* Improve carousel touch experience - only restrict touch for actual carousels */
    .featured-collection,
    .slider-component,
    .owl-carousel {
      touch-action: pan-x;
      -webkit-overflow-scrolling: touch;
    }
    
    /* Allow normal scrolling for collection grids */
    .product-grid,
    .collection-list {
      touch-action: auto;
      -webkit-overflow-scrolling: touch;
    }
    
    /* Better horizontal scrolling */
    .grid--peek,
    .slider {
      overflow-x: auto;
      overflow-y: hidden;
      scroll-snap-type: x mandatory;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      -ms-overflow-style: none;
    }
    
    .grid--peek::-webkit-scrollbar,
    .slider::-webkit-scrollbar {
      display: none;
    }
    
    .grid--peek .grid__item,
    .slider .grid__item {
      scroll-snap-align: start;
      flex-shrink: 0;
    }
    
    /* Ensure carousel items are properly sized for mobile */
    .featured-collection .grid__item,
    .product-grid .grid__item {
      min-width: 280px;
      max-width: 320px;
    }
    
    /* Add visual indicators for swipeable content */
    .grid--peek::after {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 20px;
      background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.8));
      pointer-events: none;
    }
  }
`;

// Inject carousel CSS
const carouselStyle = document.createElement('style');
carouselStyle.textContent = carouselCSS;
document.head.appendChild(carouselStyle);
